import { initializeApp } from 'firebase/app';
import {
  TotpMultiFactorGenerator,
  getAuth,
  getMultiFactorResolver,
  inMemoryPersistence,
  multiFactor,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};
const adminTotpIssuer = process.env.REACT_APP_ADMIN_TOTP_ISSUER;

if (Object.values(firebaseConfig).some((value) => !value) || !adminTotpIssuer) {
  throw new Error('Firebase admin login configuration is incomplete');
}

const auth = getAuth(initializeApp(firebaseConfig, 'yarngpt-admin-dashboard'));

export async function signInFirstFactor(email, password) {
  await setPersistence(auth, inMemoryPersistence);
  try {
    return { credential: await signInWithEmailAndPassword(auth, email, password) };
  } catch (error) {
    if (error.code !== 'auth/multi-factor-auth-required') throw error;
    return { resolver: getMultiFactorResolver(auth, error) };
  }
}

export async function completeTotpSignIn(resolver, code) {
  const totpHint = resolver.hints.find(
    (hint) => hint.factorId === TotpMultiFactorGenerator.FACTOR_ID,
  );
  if (!totpHint) throw new Error('This administrator has no authenticator-app factor');
  const assertion = TotpMultiFactorGenerator.assertionForSignIn(totpHint.uid, code);
  return resolver.resolveSignIn(assertion);
}

export async function prepareTotpEnrollment(credential) {
  const token = await credential.user.getIdTokenResult();
  if (token.claims.adminRole !== 'owner') {
    throw new Error('Admin access required');
  }
  const factors = multiFactor(credential.user);
  if (factors.enrolledFactors.length > 0) return null;
  const session = await factors.getSession();
  const secret = await TotpMultiFactorGenerator.generateSecret(session);
  return {
    qrCodeUrl: secret.generateQrCodeUrl(credential.user.email, adminTotpIssuer),
    secret,
    secretKey: secret.secretKey,
  };
}

export async function completeTotpEnrollment(user, secret, code) {
  const assertion = TotpMultiFactorGenerator.assertionForEnrollment(secret, code);
  await multiFactor(user).enroll(assertion, 'Authenticator app');
  await signOut(auth);
}
